import type { ScreenEventPayload } from '@atlassiansox/analytics-web-client/types';
import { useEffect, useRef } from 'react';

import { useRovoDevWebAnalyticsClient } from './rovo-dev-web-analytics-events';

export const FireScreenEvent = ({ name, attributes }: ScreenEventPayload) => {
	const { fireScreenEvent } = useRovoDevWebAnalyticsClient();
	const hasFired = useRef(false);

	useEffect(() => {
		if (!hasFired.current) {
			fireScreenEvent({ name, attributes });
			hasFired.current = true;
		}
	}, [fireScreenEvent, name, attributes]);

	return null;
};
